export default __webpack_public_path__ + "fed082aa2dd63b3beacf442926cd14c7.png";